var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09579 4.60188C8.36241 4.34795 8.78439 4.35825 9.03831 4.62487L11.8161 7.54153C12.0613 7.799 12.0613 8.2036 11.8161 8.46107L9.03831 11.3777C8.78439 11.6444 8.36241 11.6547 8.09579 11.4007C7.82917 11.1468 7.81887 10.7248 8.0728 10.4582L9.77778 8.66797L4.66667 8.66797C4.29848 8.66797 4 8.36949 4 8.0013C4 7.63311 4.29848 7.33464 4.66667 7.33464H9.77778L8.0728 5.54441C7.81887 5.27779 7.82917 4.8558 8.09579 4.60188Z",
    fill: "#B6BFCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightSm);
export default __webpack_public_path__ + "static/media/ic-arrow-right-sm.350359282b701e594564d4faa1bc3858.svg";
export { ForwardRef as ReactComponent };